import { Injectable, signal } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable, tap } from 'rxjs';
import { StationsResponse, StationDto } from '../models/stations.model';

@Injectable({ providedIn: 'root' })
export class StationsService extends BaseApiService {
  readonly stations = signal<StationDto[] | null>(null);
  getAllStations(): Observable<StationsResponse> {
    return this.get<StationsResponse>('/stations').pipe(
      tap((stations) => this.stations.set(stations.stations)),
    );
  }

  getStation(location: string): Observable<StationDto> {
    return this.get<StationDto>(`/stations/${encodeURIComponent(location)}`);
  }
}
